const CDN = "https://www.campinglacauxoiseaux.fr/wp-content/uploads";

export const IMAGES = {
  hero: "/images/hero-piscine.webp",
  nature: `${CDN}/2020/10/camping-nature-lac-aveyron.jpg`,
  martiel: `${CDN}/2020/08/camping-martiel.jpg`,
  mobilhome: `${CDN}/2023/12/mobil-home-premium-aveyron.jpeg`,
  emplacement: `${CDN}/2020/10/emplacement-aveyron.jpg`,
  insolite: `${CDN}/2026/02/DSC_3837.webp`,
  piscine: `${CDN}/2020/10/piscine-lac-aux-oiseaux.jpg`,
  piscineToboggan: `${CDN}/2020/10/toboggan-piscine-aveyron.jpg`,
  piscineFamille: `${CDN}/2020/10/vacances-piscine-aveyron.jpg`,
  baignade: `${CDN}/2020/10/baignade-aveyron.jpg`,
  peche: `${CDN}/2020/10/peche-lac.jpg`,
  canoe: `${CDN}/2019/12/Canoe-kayak-lac-amis.jpg`,
  millau: `${CDN}/2020/09/Viaduc-de-Millau-vue-ensemble-Aveyron.jpg`,
  animations: `${CDN}/2020/09/girafe-gonflable-2.jpg`,
  restaurant: "/images/restaurant-paella.webp",
  ferme: "/images/mini-ferme-ane.jpeg",
  village: "https://images.unsplash.com/photo-1664729594390-a2848060cabf?q=80&w=1200&auto=format&fit=crop",
};

export const YOUTUBE_URL = "https://www.youtube.com/embed/iUiQd0_K24o?rel=0";

export const BOOKING_URL = "https://reservation.secureholiday.net/fr/667/search/";

export const FLOWER_LOGO = "https://www.campinglacauxoiseaux.fr/wp-content/themes/merlin/img/flower-camping-fr.png";

export const CONTACT = {
  name: "Camping Le Lac aux Oiseaux",
  address: "800 route de Bannac, 12200 Martiel — Aveyron",
  phone: "06 11 90 97 81",
  phoneHref: "tel:+33611909781",
  email: "info@campinglacauxoiseaux.fr",
  gps: "N 44° 23′ 04″ — E 1° 53′ 12″",
  season: "Ouvert de mai à fin septembre",
};

export const HEBERGEMENTS = [
  {
    title: "Mobil-homes",
    tag: "le confort, tout simplement",
    text: "Modernes, climatisés et tout équipés, pour des vacances en famille sans contrainte. Certains modèles sont adaptés PMR.",
    image: IMAGES.mobilhome,
    rotate: "-rotate-2",
  },
  {
    title: "Emplacements",
    tag: "le vrai camping",
    text: "Spacieux et ombragés, parfaits pour planter sa tente, stationner son van ou sa caravane. Sanitaire privatif en option.",
    image: IMAGES.emplacement,
    rotate: "rotate-2",
  },
  {
    title: "Insolites",
    tag: "dormir autrement",
    text: "Nos tentes lodges sur pilotis séduisent les amoureux de nature en quête d'originalité, entre ciel et feuillage.",
    image: IMAGES.insolite,
    rotate: "-rotate-1",
  },
];

export const SERVICES = [
  { icon: "Wifi", label: "Wifi gratuit", text: "sur l'ensemble du site" },
  { icon: "WashingMachine", label: "Laverie", text: "en libre accès" },
  { icon: "ShoppingBasket", label: "Épicerie", text: "de dépannage, produits du quotidien" },
  { icon: "Bike", label: "Location de vélos", text: "pour explorer l'Aveyron" },
  { icon: "Baby", label: "Espace bébé", text: "toilette & douche enfant" },
  { icon: "Accessibility", label: "Accès PMR", text: "sanitaires adaptés" },
  { icon: "PawPrint", label: "Animaux acceptés", text: "avec supplément" },
  { icon: "CreditCard", label: "Paiements variés", text: "CB, virement, chèque, espèces" },
];

export const REVIEWS = [
  {
    name: "Pascal",
    text: "Super accueil, sanitaires très propres, lieu très calme en pleine nature. N'hésitez pas si vous passez dans l'Aveyron !",
  },
  {
    name: "Florence",
    text: "Excellent accueil et emplacements spacieux et ombragés. Nous avons passé de très bonnes vacances, merci à toute l'équipe.",
  },
  {
    name: "Laurent",
    text: "Camping propre et très bon accueil. On reviendra, c'est promis.",
  },
  {
    name: "Pascal & famille",
    text: "Un super séjour : le lodge était très accueillant, l'espace aquatique vraiment agréable et le restaurant excellent. Bravo à toute l'équipe !",
  },
  {
    name: "Florence",
    text: "Idéal pour profiter des animations et des belles visites de la région. Ambiance familiale et conviviale, équipe toujours attentionnée. Nous recommandons vivement !",
  },
];

export const REGION = [
  {
    title: "Pêche au lac de Bannac",
    text: "Lancez votre ligne dès l'aube dans un décor préservé, refuge de nombreux oiseaux.",
    image: IMAGES.peche,
  },
  {
    title: "Canoë dans les gorges de l'Aveyron",
    text: "Descendez la rivière entre falaises et forêts, au fil de l'eau.",
    image: IMAGES.canoe,
  },
  {
    title: "Bastides & cités médiévales",
    text: "Belcastel, Najac, Villefranche-de-Rouergue : des villages parmi les plus beaux de France.",
    image: IMAGES.village,
  },
  {
    title: "Viaduc de Millau",
    text: "Le géant des causses, à voir absolument lors d'une escapade d'une journée.",
    image: IMAGES.millau,
  },
  {
    title: "Animations au camping",
    text: "Club enfants, mini-ferme, structures gonflables et soirées douces en été.",
    image: IMAGES.animations,
  },
];

export const FAQ_ITEMS = [
  {
    q: "Peut-on découvrir l'Aveyron en camping-car ?",
    a: "Oui. Le camping dispose d'emplacements adaptés aux camping-cars, avec branchements électriques et services pratiques pour vous reposer le temps d'une nuit ou plus.",
  },
  {
    q: "À quelle période le camping est-il ouvert ?",
    a: "Le camping est ouvert de mai à septembre. La piscine couverte et chauffée est accessible dès l'ouverture. Le restaurant et les animations sont ouverts en juillet et août.",
  },
  {
    q: "Quels types d'hébergements propose le camping ?",
    a: "Des locations de mobil-homes (2 ou 3 chambres, climatisés), des lodges sur pilotis, des tentes Freeflower, des emplacements nus pour tente, caravane ou camping-car, et des emplacements premium avec sanitaire privatif.",
  },
  {
    q: "La piscine est-elle couverte et chauffée ?",
    a: "Oui. Le camping dispose d'une piscine couverte et chauffée avec toboggans à 3 pistes et pataugeoires, accessible à tous les vacanciers par tous les temps.",
  },
  {
    q: "Peut-on pêcher au camping ?",
    a: "Oui. Le lac de Bannac (22 hectares) est situé à 50 m du camping. L'accès est gratuit pour les campeurs munis d'une carte de pêche. Pêche en no-kill uniquement.",
  },
];

export const ACCOMMODATIONS = [
  {
    category: "mobil-home",
    name: "Homeflower Premium 2 chambres",
    people: "4 pers.",
    rooms: "2 ch.",
    size: "29 m²",
    image: `${CDN}/2019/01/mobil-home-aveyron-premium-2p.jpeg`,
    desc: "Notre mobil-home le plus premium : cuisine équipée, salon avec banquette, terrasse avec salon de jardin et parasol.",
    features: ["Climatisation", "Terrasse équipée", "Lave-vaisselle"],
  },
  {
    category: "mobil-home",
    name: "Homeflower Premium 3 chambres",
    people: "6 pers.",
    rooms: "3 ch.",
    size: "30 m²",
    image: `${CDN}/2020/10/location-aveyron-homeflower.jpg`,
    desc: "La version familiale du Premium : trois chambres et tout le confort pour une tribu, sur un emplacement spacieux.",
    features: ["Climatisation", "3 chambres", "Terrasse équipée"],
  },
  {
    category: "insolite",
    name: "Lodge Safari Premium Plus 2 ch",
    people: "4 pers.",
    rooms: "2 ch.",
    size: "35 m²",
    image: `${CDN}/2025/12/lodge-safari-prem-plus.jpg`,
    desc: "L'esprit safari avec un grand confort : lave-vaisselle, TV et large terrasse couverte pour les soirées dehors.",
    features: ["Lave-vaisselle", "TV", "Terrasse couverte"],
  },
  {
    category: "insolite",
    name: "Lodge Safari Premium Plus 3 ch",
    people: "6 pers.",
    rooms: "3 ch.",
    size: "40 m²",
    image: `${CDN}/2025/12/lodge-safari-prem-plus-6pers.jpg`,
    desc: "Le plus spacieux de nos lodges : trois chambres, lave-vaisselle, TV et terrasse couverte pour les grandes familles.",
    features: ["Lave-vaisselle", "TV", "Terrasse couverte"],
  },
  {
    category: "mobil-home",
    name: "Mobil-home Confort 3 ch Clim",
    people: "6 pers.",
    rooms: "3 ch.",
    size: "30 m²",
    image: `${CDN}/2020/10/location-mobil-home-confort.jpg`,
    desc: "Trois chambres climatisées, kitchenette équipée et salle de bain avec toilettes indépendantes.",
    features: ["Climatisation", "3 chambres", "WC séparés"],
  },
  {
    category: "mobil-home",
    name: "Mobil-home Confort 2 ch & Clim",
    people: "4 pers.",
    rooms: "2 ch.",
    size: "26 m²",
    image: `${CDN}/2020/10/mobil-home-28-confort-aveyron.jpg`,
    desc: "Le compromis idéal : deux chambres, climatisation et terrasse, parfait pour une famille avec deux enfants.",
    features: ["Climatisation", "Terrasse", "Cuisine équipée"],
  },
  {
    category: "mobil-home",
    name: "Mobil-home Confort 2 ch (Éco)",
    people: "4/5 pers.",
    rooms: "2 ch.",
    size: "29 m²",
    image: `${CDN}/2020/10/location-eco-aveyron.jpg`,
    desc: "Le confort à petit prix : climatisation et agencement malin pour des vacances maîtrisées.",
    features: ["Climatisation", "Petit budget", "Terrasse"],
  },
  {
    category: "mobil-home",
    name: "Mobil-home Confort type T 2 ch",
    people: "4 pers.",
    rooms: "2 ch.",
    size: "22,5 m²",
    image: `${CDN}/2020/10/exterieur-confort-28-aveyron.jpg`,
    desc: "Compact et fonctionnel, avec tout l'essentiel pour un séjour confortable au cœur de la nature.",
    features: ["Cuisine équipée", "Terrasse", "Salon de jardin"],
  },
  {
    category: "mobil-home",
    name: "Mobil-home Standard 3 chambres",
    people: "6 pers.",
    rooms: "3 ch.",
    size: "30 m²",
    image: `${CDN}/2020/10/exterieur-mobil-home-confort-aveyron.jpg`,
    desc: "Simple et spacieux : trois chambres pour accueillir famille ou amis sans se ruiner.",
    features: ["3 chambres", "Cuisine équipée", "Terrasse"],
  },
  {
    category: "mobil-home",
    name: "Mobil-home Confort 2 chambres",
    people: "4 pers.",
    rooms: "2 ch.",
    size: "24 m²",
    image: `${CDN}/2023/12/mobil-home-105.jpeg`,
    desc: "Deux chambres, une terrasse et tout le nécessaire pour des vacances simples et confortables.",
    features: ["Cuisine équipée", "Terrasse", "Salon de jardin"],
  },
  {
    category: "insolite",
    name: "Cabane Lodge sur Pilotis Confort",
    people: "4 pers.",
    rooms: "2 ch.",
    size: "33 m²",
    image: `${CDN}/2020/10/lodge-premium-aveyron.jpeg`,
    desc: "Bois et toile sur pilotis, salle d'eau, WC et même lave-vaisselle : la cabane tout confort avec terrasse couverte près du lac.",
    features: ["Salle d'eau + WC", "Lave-vaisselle", "Dolce Gusto & TV"],
  },
  {
    category: "insolite",
    name: "Tente sur Pilotis Standard",
    people: "4 pers.",
    rooms: "2 ch.",
    size: "23 m²",
    image: `${CDN}/2022/02/tente-sur-pilotis-aveyron.jpeg`,
    desc: "Une jolie tente de toile sur plancher bois avec terrasse abritée et vue sur les arbres et le lac. Esprit camping, version originale.",
    features: ["Vue lac", "Terrasse abritée", "Été uniquement"],
  },
  {
    category: "insolite",
    name: "Freeflower",
    people: "5 pers.",
    rooms: "2 ch.",
    size: "37 m²",
    image: `${CDN}/2023/12/freeflower-aveyron-12-lot.jpeg`,
    desc: "La grande tente à la toile kiwi ou cassis : deux chambres, kitchenette, auvent et hamac coloré. Sans sanitaires, tout le charme du camping.",
    features: ["Auvent & hamac", "Kitchenette", "Sans vis-à-vis"],
  },
  {
    category: "emplacement",
    name: "Emplacement Confort",
    people: "tente · caravane · camping-car",
    rooms: "",
    size: "grande parcelle",
    image: `${CDN}/2020/10/caravane-aveyron.jpg`,
    desc: "Parcelle spacieuse délimitée par des haies, à l'ombre des grands chênes ou au soleil, avec électricité 10 A en option et sanitaires rénovés à deux pas.",
    features: ["Électricité 10 A (option)", "Ombragé ou ensoleillé", "Proche du lac de Bannac"],
  },
  {
    category: "emplacement",
    name: "Ready To Camp",
    people: "4/5 pers.",
    rooms: "",
    size: "tente installée",
    image: `${CDN}/2020/09/tente-interieur.jpg`,
    desc: "L'esprit camping sans le matériel : la tente est déjà montée près de l'accueil, avec matelas, vaisselle, couvertures et oreillers.",
    features: ["Tente déjà installée", "Matelas & vaisselle", "Près de l'accueil"],
  },
];

export const ACCOMMODATION_CATEGORIES = [
  ["tous", "Tous"],
  ["mobil-home", "Mobil-homes"],
  ["insolite", "Insolites"],
  ["emplacement", "Emplacements"],
];

// Prix indicatifs par nuit — À CONFIRMER par le propriétaire
export const PRICE_GUIDE = {
  "Homeflower Premium 2 chambres": { low: 75, high: 135 },
  "Homeflower Premium 3 chambres": { low: 85, high: 155 },
  "Lodge Safari Premium Plus 2 ch": { low: 80, high: 145 },
  "Lodge Safari Premium Plus 3 ch": { low: 95, high: 165 },
  "Mobil-home Confort 3 ch Clim": { low: 70, high: 125 },
  "Mobil-home Confort 2 ch & Clim": { low: 60, high: 110 },
  "Mobil-home Confort 2 ch (Éco)": { low: 55, high: 100 },
  "Mobil-home Confort type T 2 ch": { low: 50, high: 95 },
  "Mobil-home Standard 3 chambres": { low: 55, high: 105 },
  "Mobil-home Confort 2 chambres": { low: 58, high: 105 },
  "Cabane Lodge sur Pilotis Confort": { low: 70, high: 125 },
  "Tente sur Pilotis Standard": { low: 50, high: 90 },
  "Freeflower": { low: 45, high: 85 },
  "Emplacement Confort": { low: 16, high: 26 },
  "Ready To Camp": { low: 35, high: 60 },
};

export const RANDOS = [
  {
    name: "Circuit des Dolmens (boucle famille)",
    distance: "1,6 km",
    duration: "~1h30",
    elevation: "Plat",
    level: "Facile",
    type: "Pédestre",
    highlights: "Dolmens datant de 2500 à 1600 av. J.-C. en pleine forêt — visites guidées en juillet-août le vendredi matin.",
    ideal: "Familles, enfants, culture",
    mapQuery: "Dolmen du Bois del Rey, Martiel",
  },
  {
    name: "Randonnée des Dolmens (grande boucle)",
    distance: "11 km",
    duration: "~3h",
    elevation: "Faible",
    level: "Modéré",
    type: "Pédestre",
    highlights: "Dolmens du Bois Del Rey, du Bois de Galtier et du Devès des Gleyettes, plus le bassin du Cloup des Gleyettes.",
    ideal: "Randonneurs intermédiaires",
    mapQuery: "Dolmens du Bois de Galtier, Martiel",
  },
  {
    name: "Tour du Lac de Bannac",
    distance: "4,1 km",
    duration: "~1h30",
    elevation: "Plat",
    level: "Facile",
    type: "Pédestre / VTT / Trail",
    highlights: "Observation de la faune sauvage, aire de pique-nique à Fontaynous, balisage PR jaune.",
    ideal: "Familles, ornithologues",
    mapQuery: "Lac de Bannac, Martiel",
  },
  {
    name: "Circuit « Lou Camin Vielh »",
    distance: "10,6 km",
    duration: "~3h",
    elevation: "Faible",
    level: "Modéré",
    type: "Pédestre",
    highlights: "Patrimoine de Martiel : lavoirs, caselles, pigeonniers — portion le long du lac de Bannac.",
    ideal: "Amateurs de patrimoine rural",
    mapQuery: "Martiel, Aveyron",
  },
  {
    name: "Circuit du Lac de Bannac (grande boucle)",
    distance: "21 km",
    duration: "~5h",
    elevation: "110 m",
    level: "Modéré",
    type: "Pédestre",
    highlights: "Magnifiques paysages, architecture rurale de la gariotte à la grande ferme quercynoise.",
    ideal: "Randonneurs confirmés, nature",
    mapQuery: "Lac de Bannac, Martiel",
  },
  {
    name: "Circuit Vélo des Puits et Fontaines",
    distance: "7,5 km",
    duration: "~2h",
    elevation: "Plat",
    level: "Facile",
    type: "Vélo / VTC",
    highlights: "Chemins bordés de murets en pierre sèche, patrimoine bâti : cazelles, puits, croix, église.",
    ideal: "Cyclistes, familles à vélo",
    mapQuery: "Martiel, Aveyron",
  },
  {
    name: "Boucle d'Elbes (commune de Martiel)",
    distance: "~6 km",
    duration: "~1h45",
    elevation: "Faible",
    level: "Facile",
    type: "Pédestre",
    highlights: "Départ du village d'Elbes, orientation facile, chemins ruraux à très faible fréquentation.",
    ideal: "Promenade tranquille, calme",
    mapQuery: "Elbes, 12200 Martiel",
  },
];

export const RAINY_IDEAS = [
  {
    name: "La Chartreuse Saint-Sauveur",
    place: "Villefranche-de-Rouergue",
    distance: "15 min",
    duration: "1h30",
    icon: "landmark",
    desc: "Chef-d'œuvre du gothique flamboyant du XVe siècle, elle abrite deux cloîtres dont l'un des plus grands de France. Une visite guidée à la bougie est même proposée certains soirs.",
    ideal: "En famille ou en couple",
  },
  {
    name: "La Chapelle des Pénitents Noirs",
    place: "Villefranche-de-Rouergue",
    distance: "15 min",
    duration: "moins d'1h",
    icon: "church",
    desc: "Derrière une façade sobre se cache un riche décor baroque avec plafond peint, retable coloré et doré, et six grands tableaux. Des visites sensorielles sont proposées : toucher, sentir, jouer avec les éléments du patrimoine — parfait pour les enfants. Entrée modeste.",
    ideal: "Avec les enfants",
  },
  {
    name: "La Grotte de Foissac",
    place: "Foissac",
    distance: "33 min",
    duration: "1h",
    icon: "cave",
    desc: "Qu'il pleuve ou qu'il vente, c'est l'endroit idéal pour découvrir les merveilles que la nature a façonnées sous terre. Site classé Monument historique avec vestiges préhistoriques. Température constante à 13 °C — prévoyez une petite veste.",
    ideal: "Curieux de tous âges",
  },
  {
    name: "Le Château de Bournazel",
    place: "Bournazel",
    distance: "20 min",
    duration: "1h30",
    icon: "castle",
    desc: "Après 15 ans de restauration exemplaire, il est considéré comme le plus beau château-musée Renaissance du Sud-Ouest. Il peut être exploré à l'abri et vous plonge dans l'histoire médiévale et de la Renaissance. Superbe même sous un ciel gris.",
    ideal: "Amateurs d'histoire",
  },
];

export const SEJOUR_IDEAL = [
  {
    day: "Mercredi",
    title: "Arrivée au camping",
    icon: "tent",
    text: "Accueillis chaleureusement par Ludovic et son équipe. Direction notre mobil-home premium — après un long voyage, quel bonheur de trouver les lits déjà faits ! Le soir, repas au restaurant du camping avec une animation familiale jusqu'à 22h30. Dodo bien mérité.",
  },
  {
    day: "Jeudi",
    title: "Marchés & produits locaux",
    icon: "basket",
    text: "Premier vrai jour de vacances. Cap sur le marché de Villefranche-de-Rouergue pour faire le plein de produits locaux. Repas en ville à midi, puis visite de Villeneuve-d'Aveyron et son incontournable boucherie pour ramener de la viande fraîche. Retour au camping pour une détente bien méritée à la piscine et sur les toboggans, avant de terminer la soirée au bar autour d'une planche de charcuterie et d'un quiz animé.",
  },
  {
    day: "Vendredi",
    title: "Journée patrimoine",
    icon: "landmark",
    text: "On récupère le pain à la réception, et à 10h c'est parti pour la visite des dolmens, organisée par le camping en partenariat avec l'association de sauvegarde du patrimoine. Les enfants sont captivés ! L'après-midi, une animation sportive laisse place à un tournoi improvisé sur le city stade.",
  },
  {
    day: "Samedi",
    title: "Journée farniente",
    icon: "sun",
    text: "Avec les départs et arrivées du week-end, la piscine est plus tranquille — on en profite pleinement. En fin d'après-midi, une petite balade autour du lac pour s'étirer les jambes et secouer la torpeur.",
  },
  {
    day: "Dimanche",
    title: "Grande escapade dans le Lot",
    icon: "car",
    text: "Lever tardif, puis en voiture direction les Phosphatières du Cloup d'Aural. Enthousiasmés par les paysages du Lot, on poursuit jusqu'à Cahors. Les enfants veulent se baigner : on redescend sur la rivière Lot à Saint-Cirq-Lapopie. Le soir, flânerie et repas à Cajarc.",
  },
  {
    day: "Lundi",
    title: "Les grands sites de l'Aveyron",
    icon: "castle",
    text: "Journée chargée mais mémorable. Viennoiseries récupérées au dépôt de la réception, puis en route pour Rodez. En chemin, visite des châteaux de Belcastel et Bournazel. Repas place d'Armes face à la cathédrale, puis le musée Soulages pour digérer tout ça. Une glace à Marcillac-Vallon et sa fameuse pierre rouge, visite de Salles-la-Source, et en cerise sur le gâteau : Conques. Retour par la magnifique vallée du Lot. Au camping, épuisés mais heureux — repas rapide et coucher tôt.",
  },
  {
    day: "Mardi",
    title: "Journée 100 % enfants",
    icon: "blocks",
    text: "Matinée au parc de jeux de Maleville, et l'après-midi, grande aventure en canoë sur l'Aveyron à Villefranche-de-Rouergue !",
  },
  {
    day: "Mercredi",
    title: "Dernier jour, tête pleine de souvenirs",
    icon: "coffee",
    text: "Pas question de baisser les bras. On rend les clés, le patron nous offre même le café ! Direction Najac : visite du château, puis sensations fortes à l'accrobranche l'après-midi. En guise de dernier repas, le marché gourmand s'impose. Et c'est reparti, la tête et le cœur plein de souvenirs.",
  },
];

export const SEJOUR_MAPS = [
  "Camping Le Lac aux Oiseaux, 800 route de Bannac, Martiel",
  "Villefranche-de-Rouergue",
  "Dolmen du Bois del Rey, Martiel",
  "Lac de Bannac, Martiel",
  "Saint-Cirq-Lapopie",
  "Musée Soulages, Rodez",
  "Maleville",
  "Château de Najac",
];

export const LEGAL_PAGES = {
  "mentions-legales": {
    title: "Mentions légales",
    intro: "Conformément aux articles 6-III et 19 de la loi pour la Confiance dans l'Économie Numérique, voici les informations légales relatives au site du Camping Le Lac aux Oiseaux.",
    sections: [
      {
        h: "Éditeur du site",
        paragraphs: [
          "Camping Le Lac aux Oiseaux — 800 route de Bannac, 12200 Martiel, Aveyron, France.",
          "Téléphone : 06 11 90 97 81 — Email : info@campinglacauxoiseaux.fr.",
          "Numéro SIRET : 411 550 023 00021. Directeur de la publication : la direction du camping.",
        ],
      },
      {
        h: "Hébergement du site",
        paragraphs: [
          "Ce site est hébergé sur la plateforme Emergent (emergent.sh). Les données des formulaires sont stockées de manière sécurisée sur cette infrastructure.",
        ],
      },
      {
        h: "Réservation en ligne",
        paragraphs: [
          "Les réservations sont traitées par notre partenaire SecureHoliday (reservation.secureholiday.net), qui applique ses propres conditions générales de vente et mentions légales au moment du règlement.",
        ],
      },
      {
        h: "Propriété intellectuelle",
        paragraphs: [
          "L'ensemble des contenus du site (textes, photographies, vidéo, identité visuelle) est la propriété du Camping Le Lac aux Oiseaux, sauf mention contraire. Le logo et la charte Flower Campings appartiennent au réseau Flower Campings.",
          "Toute reproduction ou réutilisation sans autorisation écrite préalable est interdite.",
        ],
      },
      {
        h: "Crédits",
        paragraphs: [
          "Photographies : © Camping Le Lac aux Oiseaux. Certaines visuels d'illustration : Unsplash (licence libre).",
        ],
      },
    ],
  },
  "politique-confidentialite": {
    title: "Politique de confidentialité",
    intro: "Nous attachons une grande importance à la protection de vos données personnelles. Cette page explique, en toute transparence, comment nous les traitons conformément au RGPD.",
    sections: [
      {
        h: "Responsable de traitement",
        paragraphs: [
          "Camping Le Lac aux Oiseaux — 800 route de Bannac, 12200 Martiel. Contact : info@campinglacauxoiseaux.fr ou 06 11 90 97 81.",
        ],
      },
      {
        h: "Données collectées",
        paragraphs: [
          "Via nos formulaires de demande de réservation et de contact : nom, adresse email, numéro de téléphone, dates et type de séjour souhaités, nombre de voyageurs et votre message.",
          "Une mesure d'audience technique peut également être réalisée de manière anonymisée afin d'améliorer le site.",
        ],
      },
      {
        h: "Finalités et base légale",
        paragraphs: [
          "Vos données servent uniquement à répondre à votre demande, préparer votre séjour et vous recontacter. Elles ne sont jamais vendues ni utilisées à des fins publicitaires.",
        ],
      },
      {
        h: "Durée de conservation",
        paragraphs: [
          "Les demandes sont conservées au maximum 3 ans après notre dernier échange, puis supprimées.",
        ],
      },
      {
        h: "Destinataires et sous-traitants",
        paragraphs: [
          "Seule l'équipe du camping accède à vos informations. Les notifications par email transitent par un prestataire d'envoi technique, et la réservation en ligne par SecureHoliday, dans le respect du RGPD.",
        ],
      },
      {
        h: "Vos droits",
        paragraphs: [
          "Vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition concernant vos données. Il suffit de nous écrire à info@campinglacauxoiseaux.fr.",
          "Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
        ],
      },
      {
        h: "Cookies",
        paragraphs: [
          "Ce site n'utilise pas de cookies publicitaires. Seuls des traceurs techniques de mesure d'audience peuvent être déposés pour améliorer votre expérience.",
        ],
      },
    ],
  },
};
